<template>
    <div>
        <h6 class="mb-2">Plusieurs véhicules trouvés</h6>
        <p class="text-muted small mb-3">Sélectionnez le véhicule à afficher :</p>
        <ul class="list-group">
            <li v-for="b in balises" :key="b.id"
                class="list-group-item d-flex align-items-center justify-content-between" role="button"
                @click="$emit('select', b)">
                <div class="d-flex align-items-center flex-grow-1 me-2">
                    <img v-if="b.icon" :src="`/img/cars/${b.icon}`" alt="" class="rvp-vehicle-icon me-2" />
                    <span class="text-truncate">
                        {{ b.name }} <span class="text-muted">({{ b.immat }})</span>
                    </span>
                </div>
                <span class="badge bg-light text-dark">
                    {{ (b.lastSpeed ?? 0) }} km/h
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'RightVehiclePicker',
    props: {
        balises: { type: Array, required: true },
    },
    emits: ['select'],
};
</script>

<style scoped>
.rvp-vehicle-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}
</style>
